/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Anonymise_What_1Inputs */

const cs_gdpr_anonymise_what_1 = /** @type {(inputs: Gdpr_Anonymise_What_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jméno se nahradí textem „Anonymizováno“`)
};

const en_gdpr_anonymise_what_1 = /** @type {(inputs: Gdpr_Anonymise_What_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the name becomes “Anonymised”`)
};

/**
* | output |
* | --- |
* | "the name becomes “Anonymised”" |
*
* @param {Gdpr_Anonymise_What_1Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_anonymise_what_1 = /** @type {((inputs?: Gdpr_Anonymise_What_1Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Anonymise_What_1Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_anonymise_what_1(inputs)
	return cs_gdpr_anonymise_what_1(inputs)
});